import { render, staticRenderFns } from "./BasketPage.vue?vue&type=template&id=29210857&scoped=true&"
import script from "./BasketPage.vue?vue&type=script&lang=js&"
export * from "./BasketPage.vue?vue&type=script&lang=js&"
import style0 from "./BasketPage.vue?vue&type=style&index=0&id=29210857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29210857",
  null
  
)

export default component.exports